import { Router } from '@angular/router';

export interface ICommonSearchArgs {
  SearchFor: string;
  VanJaar?: number;
  TotJaar?: number;
  PeriodeFilter?: string;
  CurrentPage?: number;
  PageSize?: number;
  CombineWordsWith: ' and ' | ' or ';
  SoortZittingId?: number;
  DiversePublicatieBestemmingIdAtHome?: number;
  SoortNotities?: 'alle' | 'eigen';
  t?: number;
}

export interface ICommonSearchRouteArgs {
  SearchFor: string;
  VanJaar?: string;
  TotJaar?: string;
  PeriodeFilter?: string;
  CurrentPage?: string;
  PageSize?: string;
  CombineWordsWith: ' and ' | ' or ';
  SoortZittingId?: string;
  DiversePublicatieBestemmingIdAtHome?: string;
  SoortNotities?: 'alle' | 'eigen';

}

function mapArgToNumber(value: string | undefined | null, defaults: { undefinedValue?: undefined | null | number, nullStringValue?: undefined | null | number }) {
  if (value === 'null' && defaults) { return defaults.nullStringValue; }
  if (value === undefined && defaults) { return defaults.undefinedValue; }
  if (typeof (value) === 'string') { return parseInt(value, 10); }
}

const nullDefault = { undefinedValue: null, nullStringValue: null };
const zeroDefault = { undefinedValue: 0, nullStringValue: 0 };


export function getSearchArgFromRoute(routeSearchArg: ICommonSearchRouteArgs) {
  const searchArg: ICommonSearchArgs = {
    SearchFor: routeSearchArg.SearchFor ?? '',
    VanJaar: mapArgToNumber(routeSearchArg.VanJaar, nullDefault),
    TotJaar: mapArgToNumber(routeSearchArg.TotJaar, nullDefault),
    PeriodeFilter: routeSearchArg.PeriodeFilter ?? 'y',
    CurrentPage: mapArgToNumber(routeSearchArg.CurrentPage, zeroDefault),
    PageSize: mapArgToNumber(routeSearchArg.PageSize, zeroDefault),
    CombineWordsWith: routeSearchArg.CombineWordsWith ?? ' or ',
    SoortZittingId: mapArgToNumber(routeSearchArg.SoortZittingId, nullDefault),
    DiversePublicatieBestemmingIdAtHome: mapArgToNumber(routeSearchArg.DiversePublicatieBestemmingIdAtHome, nullDefault),
    SoortNotities: routeSearchArg.SoortNotities ?? 'alle'
  };
  return searchArg;
}

export function getDefaultSearchArgs(): ICommonSearchArgs {
  return {
    SearchFor: '',
    PeriodeFilter: 'y',
    CombineWordsWith: ' or ',
    SoortZittingId: null,
    CurrentPage: 0,
    VanJaar: null,
    TotJaar: null,
  };
}
